import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-media-folder-icon',
  templateUrl: './files-media-folder.component.html'
})
export class FilesMediaFolderComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
